import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// GTM padrão da Menucheff no painel. Vazio = desligado.
const GTM_ID = process.env.REACT_APP_GTM_ID || '';
const GTM_ID_REGEX = /^GTM-[A-Z0-9]{4,12}$/;

// No Electron (app desktop) o tráfego não é útil para análise, então o GTM fica desligado.
const isElectron = () => /electron/i.test(window.navigator.userAgent);

const isEnabled = () =>
  !!GTM_ID && GTM_ID_REGEX.test(GTM_ID) && !isElectron();

export function initGoogleTagManager() {
  if (!isEnabled() || window.google_tag_manager?.[GTM_ID]) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(script);
}

export function pushDataLayer(data) {
  if (!isEnabled()) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
}

// Envia um page_view virtual a cada troca de rota (SPA).
export function GoogleTagManagerRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    pushDataLayer({
      event: 'page_view',
      page_path: location.pathname + location.search,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
}
